import type { OverviewPayload, Role } from './types';
import { ownerOverview, staffOverview } from './mocks';

const FETCH_TIMEOUT_MS = 10_000;

export async function fetchOverview(role: Role): Promise<OverviewPayload> {
  if (import.meta.env.VITE_USE_MOCKS === '1') {
    return role === 'staff' ? staffOverview : ownerOverview;
  }
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
  try {
    const res = await fetch('/api/overview', {
      credentials: 'same-origin',
      signal: controller.signal,
    });
    if (!res.ok) {
      throw new Error(`fetchOverview failed: ${res.status}`);
    }
    return (await res.json()) as OverviewPayload;
  } catch (err) {
    if (err instanceof DOMException && err.name === 'AbortError') {
      throw new Error(`fetchOverview timed out after ${FETCH_TIMEOUT_MS}ms`);
    }
    throw err;
  } finally {
    clearTimeout(timer);
  }
}
